import { Component, OnInit } from "@angular/core";
import { AuthService } from "app/core/services/auth.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { UserService } from "app/core/services/user.service";
import { Loading } from "../../../core/models/loading";
import { CustomError } from "../../../core/models/custom-error";
import { CurrentUserService } from "app/core/services/current-user.service";

@Component({
  selector: "app-guest",
  templateUrl: "./guest.component.html",
  styleUrls: ["./guest.component.scss"]
})
export class GuestComponent implements OnInit {
  loading: Loading = new Loading(true, "Validating access...");

  loadError: CustomError;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private currentUserService: CurrentUserService
  ) { }

  async ngOnInit() {
    //logout current user

    this.authService.logout();

    const token = this.route.snapshot.queryParams["token"];

    if (!token) {

      this.loading.isLoading = false;
      this.loadError = new CustomError(
        "401",
        "Authentication Error",
        "Authentication token was not provided.",
        null
      )

    } else if (token) {
      try {
        //submit token to API to verify
        const userData = await this.authService.loginAsGuestUser(token);


        const currentUser = await this.userService.getUser();

        this.currentUserService.setCurrentUser(currentUser);


        this.router
          .navigate(["/user/courses", userData.courseId], {
            queryParams: { token: token }
          })
          .then(() => {
            this.loading.isLoading = false;
          });
      } catch (error) {

        this.loadError =
          new CustomError(
            "401",
            "Invalid Token",
            "Provided token is invalid. Please login if you have an account, or create an account to access this course.",
            null
          );


        this.loading.isLoading = false;
      }
    }


  }
}
